/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

<template>
  <div id="app">
    <div class="ui inverted top fixed menu">
      <div class="ui container">
        <router-link
          to="/"
          class="header item"
        >
          <img
            class="ui mini image"
            src="./assets/humanelogo.png"
          >
          &nbsp;
          Device Dashboard
        </router-link>
        <a
          class="item"
          v-if="authState && !authState.isAuthenticated"
          v-on:click="login()"
        >
        Login
        </a>
        <router-link
          to="/devices"
          class="item"
          id="devices-button"
          v-if="authState && authState.isAuthenticated"
        >
          <i
            aria-hidden="true"
            class="microchip icon">
          </i>
          Devices
        </router-link>
        <!-- <router-link
          to="/team"
          class="item"
          id="team-button"
          v-if="authState && authState.isAuthenticated"
        >
          <i
            aria-hidden="true"
            class="users icon">
          </i>
          Team
        </router-link> -->
        <a
          id="logout-button"
          class="item"
          v-if="authState && authState.isAuthenticated"
          v-on:click="logout()"
        >
        Logout
        </a>
      </div>
    </div>
    <div
    class="ui text container"
    style="margin-top: 7em;"
    >
    <router-view/>
    </div>
    <AuthRequiredModal ref="authRequiredModal" />
  </div>
</template>

<script>
import AuthRequiredModal from './components/AuthRequiredModal.vue';
export default {
  name: 'app',
  components: {
    AuthRequiredModal,
  },
  methods: {
    onAuthRequired(oktaAuth) {
      if (!oktaAuth.authStateManager.getPreviousAuthState()?.isAuthenticated) {
        // App initialization stage
        oktaAuth.signInWithRedirect();
      } else {
        // Ask the user to trigger the login process during token autoRenew process
        this.$refs.authRequiredModal.showModal(oktaAuth);
      }
    },
    login () {
      this.$auth.signInWithRedirect({ originalUri: '/devices' })
    },
    async logout () {
      const publicPath = this.$route.href.replace(new RegExp(this.$route.fullPath + '$'), '');
      await this.$auth.signOut({ postLogoutRedirectUri: `${window.location.origin}${publicPath}` })
    }
  }
}
</script>
